import { PAGE_LOADER_WEB_CONTAINER_ID } from './PageLoaderElement.contants';

export const hidePageLoader = () => {
  const pageLoaderContainer = document.getElementById(PAGE_LOADER_WEB_CONTAINER_ID);
  if (pageLoaderContainer) {
    pageLoaderContainer.style.display = 'none';
  }
};
